import { Text, Stack, TextInput } from '@mantine/core';
import { formatPhoneNumber, normalizePhoneNumber } from '@bariendo/lib/phone-validations';
import { EditableField, EditableFieldProps, EditableFieldRenderInputProps } from './EditableField';
import { checkPhoneValidation } from './services';

export type PhoneEditableFieldProps = Omit<EditableFieldProps, 'renderInput' | 'liveValidate' | 'normalizeValue'>;

function PhoneInput(props: EditableFieldRenderInputProps) {
  const { value, onChange, onBlur, onKeyDown, disabled, validationError, inputRef, inputProps } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  // Merge styles from inputProps with validation styles
  const mergedStyles = {
    ...inputProps?.styles,
    input: {
      ...(inputProps?.styles as any)?.input,
      borderColor: validationError ? 'var(--mantine-color-red-6)' : (inputProps?.styles as any)?.input?.borderColor,
    },
  };

  return (
    <Stack gap={2} style={{ width: '100%' }}>
      <TextInput
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        disabled={disabled}
        ref={inputRef}
        autoFocus
        placeholder="+1 (555) 123-4567"
        {...inputProps}
        styles={mergedStyles}
        error={!!validationError}
      />
      {validationError && (
        <Text size="xs" c="red" style={{ fontSize: '10px' }}>
          {validationError}
        </Text>
      )}
    </Stack>
  );
}

export function PhoneEditableField(props: PhoneEditableFieldProps) {
  return (
    <EditableField
      {...props}
      displayValue={formatPhoneNumber(props.value)}
      liveValidate={checkPhoneValidation}
      normalizeValue={normalizePhoneNumber}
      InputComponent={PhoneInput}
    />
  );
}
